module.exports = __webpack_public_path__ + "static/media/iceland-pool.09fd77ba.jpg";